export enum EnumSolicitacaoCompraTipoFrete {
	EMITENTE, 
    DESTINATARIO, 
    TERCEIROS, 
    SEM_COBRANCA
}